import type { TutorBillingFlagsPatch } from '../model/types'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useTutorBillingStore } from '../model/store'

export const useTutorBillingBulkFlags = async (ids: number[], flags: TutorBillingFlagsPatch): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useTutorBillingStore()

  const url = useAdminRoutes('admin.tutors.billing.bulk-flags')

  store.setSaving(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    const { data } = await $axios.patch<ApiResponse>(url, { ids, ...flags })

    if (!data.success) {
      toast.error(data.message)
      return false
    }

    toast.success(data.message)

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    store.setSaving(false)
  }
}
